import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersThree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayersThree"><Path d="M22.2378 12.0001L12.0017 17.1181L1.76564 12.0001L4.00169 10.8821L12.0017 14.8821L20.0017 10.8821L22.2378 12.0001Z" fill="currentColor"/><Path d="M22.2378 16.0001L12.0017 21.1181L1.76562 16.0001L4.00168 14.8821L12.0017 18.8821L20.0017 14.8821L22.2378 16.0001Z" fill="currentColor"/><Path d="M12.0017 2.88208L1.76562 8.00011L12.0017 13.1181L22.2378 8.00011L12.0017 2.88208Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersThree;
